// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { CLONE_IMAGE_STATUS } from "@/constant/rental";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            numberOfCopy: 1,
            cloneImageStatus: CLONE_IMAGE_STATUS,
            dataNote: [
                {
                    label: this.$t('cloneImageModal.notesTitle'),
                    children: [
                        {
                            label: this.$t('cloneImageModal.note1'),
                        },
                        {
                            label: this.$t('cloneImageModal.note2'),
                        },
                    ]
                },
            ],
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.CLONE_IMAGE);
        },
        //#endregion

        //#region Remove image 
        clone() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    numberOfCopy: this.numberOfCopy,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.CLONE_IMAGE, data)
                    .then((res) => {
                        switch (res.errorCode) {
                            case CLONE_IMAGE_STATUS.SUCCESS:
                                EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                                EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                                this.closeThisPopup();
                                this.notificationSuccess(this.$t('cloneImageModal.duplicatingTitle'), this.$t('cloneImageModal.duplicatingMessage', { id: this.targetImage.id, name: this.targetImage.name }));
                                break;
                            case CLONE_IMAGE_STATUS.BALANCE_NOT_ENOUGH:
                            case CLONE_IMAGE_STATUS.NO_DEPOSIT:
                            case CLONE_IMAGE_STATUS.LIMITED_IMAGE:
                            case CLONE_IMAGE_STATUS.MAXIMUM_PER_REQUEST:
                                setTimeout(() => {
                                    this.isShowErrorInformation = true;
                                }, 500);
                                this.errorCode = res.errorCode
                                break;
                        }
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('cloneImageModal.cloneFailed'))
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}